<div class="container">
    <div *ngIf="loadMenus" id="loadingPage"></div>
    <div class="row p-70 menus" *ngIf="!loadMenus">
        <div class="col-xs-6 menus-c" *ngFor="let menu of menus;let i=index">
            <menu-card [menu]="menu"></menu-card>
        </div>
    </div>
    <div>
        <div class="alert alert-danger text-center" *ngIf="!loadMenus && menucategorie.id && menus.length==0">
            Menu non disponible
            <ng-container *ngIf="orderType==1">en livraison</ng-container>
            <ng-container *ngIf="orderType==3">à emporter</ng-container>
            <ng-container *ngIf="orderType==2">sur place</ng-container>
        </div>
    </div>
</div>